import { c as _c } from "react/compiler-runtime";
import { getTranslations } from 'next-intl/server';
import { LazyImage } from '@/components/partials';
import HomePresentationWrapper from './home-presentation-wrapper';
import mainPicture01 from '@/assets/img/main-pic-01.png';
import mainPicture02 from '@/assets/img/main-pic-02.png';
const HomePresentation = async () => {
  const $ = _c(2);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const t = await getTranslations();
      const title = t("home_presentation_title");
      const text = t("home_presentation_text");
      if (!text) {
        t1 = null;
        break bb0;
      }
      t0 = <HomePresentationWrapper><div className="hp-text flex flex-col items-start justify-center space-y-4 px-4 md:px-0"><h2 className="w-full text-center text-2xl font-medium">{title}</h2><p className="text-center text-gray-500">{text}</p></div><div className="flex w-full flex-col gap-4 md:flex-row md:items-stretch"><div className="hp-img-left z-0 w-full md:flex-1"><LazyImage src={mainPicture01} alt={title} className="aspect-4/3 w-full object-cover" /></div><div className="hp-img-right relative z-10 flex w-full flex-col bg-gray-100 md:flex-1"><div className="hp-callout bg-brand z-10 flex w-full flex-col items-start justify-center space-y-2 p-5 text-gray-800 md:absolute md:bottom-10 md:-left-30 md:w-60"><h3 className="font-bold">{t("customized_production_title")}</h3><p className="text-sm">{t("customized_production_text")}</p></div><div className="aspect-4/3 w-full flex-1 overflow-hidden md:aspect-auto md:h-full"><LazyImage src={mainPicture02} alt={t("customized_production_title")} className="h-full w-full object-cover" /></div></div></div></HomePresentationWrapper>;
    }
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  return t0;
};
export default HomePresentation;